// extracted by mini-css-extract-plugin
module.exports = {"button":"DownloadAppButton_button__Jz8Rr","textContainer":"DownloadAppButton_textContainer__Xsdbm","iconContainer":"DownloadAppButton_iconContainer__6Wurg"};